import { render } from "./NodePagination.vue?vue&type=template&id=8ec618f0&scoped=true&ts=true"
import script from "./NodePagination.vue?vue&type=script&lang=ts"
export * from "./NodePagination.vue?vue&type=script&lang=ts"

import "./NodePagination.vue?vue&type=style&index=0&id=8ec618f0&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8ec618f0"]])

export default __exports__